// extracted by mini-css-extract-plugin
module.exports = {"head":"head__0rcj7CnCRq5ue","section":"section__xrHt7PW2Chcag","inputDescription":"inputDescription__4z-O0ay-jfA2O","error":"error__3v0viV+kODfNH"};